import { render } from "./Book1.vue?vue&type=template&id=7d84ae09"
import script from "./Book1.vue?vue&type=script&lang=js"
export * from "./Book1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__